import styled from '@emotion/styled';
import { nav } from 'src/assets/colors';
import { MenuButtonWrapper, MenuItemsNavigation } from 'src/components/Menu/Menu.style';

export const MenuItemsNavigationCms = styled(MenuItemsNavigation, { label: 'MenuItemsNavigationCms' })`
    flex: 0 0 248px;
    width: 248px;
    background-color: ${nav.cms.bgColor};
`;

export const MenuButtonWrapperCms = styled(MenuButtonWrapper, { label: 'MenuButtonWrapperCms' })`
background: ${nav.cms.bgColorSecondary} !important;
    color: ${({ isActive }): string => isActive ? nav.cms.txtColorSecondary : nav.cms.txtColor};

    &:hover {
        color: ${nav.cms.txtColorSecondary};

        &:before {
            opacity: 0;
        }
    }
`;
